export const DISCOUNT_PERCENTAGE = 50 ;